export default "__VITE_ASSET__CipPAVl___"